import React from 'react';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import ChatBubbles from '../../Icons/Group/ChatBubbles';
import Clipboard from '../../Icons/Group/Clipboard';
import Flag from '../../Icons/Group/Flag';
import Trees from '../../Icons/UserProfile/Trees';
/* COMPONENTS */
import Button from '../../Input/Button/Button';

import StoryCard from '../StoryCard/StoryCard';
/* STYLESHEETS */
import './MarketingSection.scss';

const STORY_CARD_CONTENTS = {
    PLATFORM: {
        image: '/v1569527294/Groups/typing-on-laptop.jpg',
        title: 'A platform you can trust',
        description:
            'The free Fairygodboss platform provides a safe, constructive and inclusive community to engage your group members. There is no cost or limit to your group size.',
    },
    ENGAGE: {
        image: '/v1569861706/Groups/posts.jpg',
        title: 'Engage with your group',
        description: `A real-time feed supports your group's posts, photos, links and messages. All of it is searchable and easy to find. From group chats to private chats, each has its place. We'll never delete or limit the number of messages you have.`,
    },
    INVITE: {
        image: '/v1569861706/Groups/cellphone.jpg',
        title: 'Invite your network and manage your group',
        description: `Easily manage your group's privacy settings and invite your current network and FGB members to join. You can manage your members' settings including requests to join and designating group administrators and moderators.`,
    },
    GROW: {
        image: '/v1569861706/Groups/invite-others.jpg',
        title: 'Grow your network',
        description:
            'We make it easier to find new group members and build your community.',
    },
};

export default class MarketingSection extends React.PureComponent {
    constructor(props) {
        super();

        this.containerRef = React.createRef();
    }

    renderHeadingSection = () => {
        return (
            <div className="heading-section">
                <h1>Create a new group</h1>
                <p className="heading-description">
                    Start a group to connect with like-minded women.
                </p>
                <a href="/groups/edit">
                    <Button
                        onClick={this.handleMetrics}
                        className="first-cta"
                        type="purple-medium-white"
                        value="Get started"
                    />
                </a>
            </div>
        );
    };

    renderStoryCards = () => {
        const { PLATFORM, ENGAGE, INVITE, GROW } = STORY_CARD_CONTENTS;

        return (
            <React.Fragment>
                <StoryCard
                    image={PLATFORM.image}
                    icon={<Flag />}
                    title={PLATFORM.title}
                    description={PLATFORM.description}
                />
                <StoryCard
                    image={ENGAGE.image}
                    icon={<ChatBubbles />}
                    title={ENGAGE.title}
                    description={ENGAGE.description}
                />
                <StoryCard
                    image={INVITE.image}
                    icon={<Clipboard />}
                    title={INVITE.title}
                    description={INVITE.description}
                />
                <StoryCard
                    image={GROW.image}
                    icon={<Trees />}
                    title={GROW.title}
                    description={GROW.description}
                />
            </React.Fragment>
        );
    };

    handleMetrics = () =>
        EmitMetric({
            misc_event_type: 'get-started-create-group-lander-click',
            misc_event_count: 1,
        });

    renderBottomCtaButton = () => {
        return (
            <a href="/groups/edit">
                <Button
                    onClick={this.handleMetrics}
                    className="second-cta"
                    type="purple-medium-white"
                    value="Get started"
                />
            </a>
        );
    };

    render() {
        return (
            <section
                ref={this.containerRef}
                className="component-Groups-MarketingSection"
            >
                {this.renderHeadingSection()}
                {this.renderStoryCards()}
                {this.renderBottomCtaButton()}
            </section>
        );
    }
}
